// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-link-button,.v-link-button__item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;margin:auto}.v-link-button__item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;max-width:335px;height:48px;padding:10px;line-height:14px;text-decoration:none!important}", ""]);
// Exports
module.exports = exports;
